module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av221-67906d4cad549d8b11cbe984a8ea8521.jpg";